// PATH: src/components/activation/activationText.ts
// Textes de confirmation de l'ouverture aux élèves, à part du hook : purs, donc testables sans client HTTP.
import type { SubjectActivation } from "../../models/domain";

export const KEPT = "Rien n'est supprimé : objectifs, faits, progression et quêtes des élèves sont conservés.";

const plural = (n: number, one: string, many: string) => `${n} ${n > 1 ? many : one}`;

/** Le texte de confirmation d'une matière, à partir de ce qu'elle porte. */
export const subjectConfirmMessage = (name: string, next: boolean, a: SubjectActivation): string => {
  if (!next) {
    return (
      `« ${name} » disparaît pour les élèves avec ${plural(a.courses, "cours", "cours")}` +
      " : plus de catalogue, de parcours ni de nouvelle quête. " +
      KEPT
    );
  }
  const closed = a.courses - a.active_courses;
  return (
    `« ${name} » réapparaît pour les élèves avec ${plural(a.active_courses, "cours ouvert", "cours ouverts")}` +
    (closed > 0 ? ` ; ${plural(closed, "cours fermé un à un reste fermé", "cours fermés un à un restent fermés")}.` : ".")
  );
};
